import { render, staticRenderFns } from "./SignedSoas.vue?vue&type=template&id=49a7a7f2&lang=pug"
import script from "./SignedSoas.vue?vue&type=script&lang=js"
export * from "./SignedSoas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Summary: require('/home/docker/code/frontend/components/Summary.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default,SendPreConsultForm: require('/home/docker/code/frontend/components/SendPreConsultForm.vue').default,SendAepSurveyForm: require('/home/docker/code/frontend/components/SendAepSurveyForm.vue').default})
